export default __webpack_public_path__ + "static/media/file.c2673b5c.svg";